(function () {
  'use strict';

  if (window.__AGO_CART_FRAGMENT_GUARD_V1__) return;
  window.__AGO_CART_FRAGMENT_GUARD_V1__ = true;

  var boundary = '[split_t4nt0]';
  var separator = '[split_t4nt]';

  function extractCartMarkup(markup) {
    var first = markup.indexOf(boundary);
    var last = markup.lastIndexOf(boundary);
    if (first === -1 || last <= first) return '';
    return markup.slice(first + boundary.length, last).split(separator)[0] || '';
  }

  function refreshLazyImages(root) {
    if (!window.lazySizes || !window.lazySizes.loader || typeof window.lazySizes.loader.unveil !== 'function') return;
    root.querySelectorAll('.lazyloadt4s').forEach(function (image) {
      window.lazySizes.loader.unveil(image);
    });
  }

  function repairCartFragment(root) {
    if (!root || root.dataset.agoCartFragmentRepairing === 'true') return false;
    var nextMarkup = extractCartMarkup(root.innerHTML || '');
    if (!nextMarkup) return false;
    root.dataset.agoCartFragmentRepairing = 'true';
    root.innerHTML = nextMarkup;
    window.requestAnimationFrame(function () {
      root.dataset.agoCartFragmentRepairing = 'false';
      refreshLazyImages(root);
      document.dispatchEvent(new CustomEvent('ago:cart-fragment-repaired'));
    });
    return true;
  }

  function observeCartRoot(root) {
    if (!root || root.dataset.agoCartFragmentGuardAttached === 'true') return;
    root.dataset.agoCartFragmentGuardAttached = 'true';
    repairCartFragment(root);
    new MutationObserver(function () {
      repairCartFragment(root);
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  function boot() {
    document.querySelectorAll('.js_cat_items').forEach(observeCartRoot);
    new MutationObserver(function () {
      document.querySelectorAll('.js_cat_items').forEach(observeCartRoot);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}());
